import React from 'react'
import classNames from 'classnames'

import { PaginationList } from './PaginationList/PaginationList'
import PaginationArrowButton from './PaginationArrowButton/PaginationArrowButton'
import { ArrowDirection } from './contants'

import styles from './Pagination.scss'
import PropTypes from 'prop-types'

export class Pagination extends React.PureComponent {
    static propTypes = {
        pagesCount: PropTypes.number.isRequired,
        className: PropTypes.string,
        selectedPage: PropTypes.number,
        hasArrow: PropTypes.bool,
        hasPageButtons: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
    }

    static defaultProps = {
        hasPageButtons: true,
    }

    state = {
        currentSelected: this.props.selectedPage || 0,
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.currentSelected !== this.state.currentSelected) {
            this.props.onChange(this.state.currentSelected)
        }
    }

    handleRenderClick = (value) => {
        this.setState({ currentSelected: value })
    }

    handleLeftArrowClick = () => {
        this.setState({ currentSelected: this.state.currentSelected - 1 })
    }

    handleRightArrowClick = () => {
        this.setState({ currentSelected: this.state.currentSelected + 1 })
    }

    render() {
        const { pagesCount, children, className, hasArrow, hasPageButtons } = this.props
        const baseClassName = classNames(
            styles.base,
            className,
        )

        return (
            <div className={baseClassName}>
                <div className={styles.content}>
                    {hasArrow && (
                        <PaginationArrowButton
                            onClick={this.handleLeftArrowClick}
                            direction={ArrowDirection.Back}
                            isLocked={this.state.currentSelected === 0}
                        />
                    )}
                    <div className={styles.children}>
                        {children}
                    </div>
                    {hasArrow && (
                        <PaginationArrowButton
                            onClick={this.handleRightArrowClick}
                            direction={ArrowDirection.Forward}
                            isLocked={this.state.currentSelected === pagesCount - 1}
                        />
                    )}
                </div>
                {hasPageButtons && (
                    <PaginationList
                        className={styles.list}
                        selectedPage={this.state.currentSelected}
                        pagesCount={pagesCount}
                        onChange={this.handleRenderClick}
                    />
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/Pagination/Pagination.jsx